import React, {useEffect} from "react";
import {connect} from "react-redux";
import {useHistory} from "react-router-dom";
import {SimpleFacilityDto} from "@reside/reside-api-app";
import {select, AppState} from "../../store";
import {AdminLayout} from "../../atoms/admin-layout";
import {DocumentTitle} from "../../atoms/document-title";
import {UserDetail} from "../../store/users/usersModel";
import {useFacilitySettingsParams} from "./route";
import {Facilities} from "../../models/types/AdmissionForm";
import {PageBody} from "./PageBody";

type Props = Readonly<{
  user: UserDetail;
  firstFacility: SimpleFacilityDto;
  facilities: Facilities;
}>;

export const PageAdminFacilitySettingsPresenter = ({
  user,
  firstFacility,
  facilities,
}: Props) => {
  const {facilityId} = useFacilitySettingsParams();
  const history = useHistory();

  // TODO: We should get rid of this.
  const hasFacilityId = facilityId !== "_";

  useEffect(() => {
    if (facilityId === "_" && firstFacility) {
      history.push(`/admin/facility/${firstFacility.id}/facility-settings`);
    }
  }, [firstFacility, facilityId, hasFacilityId, history]);

  return (
    <>
      <DocumentTitle title="Reside - Admin - Facility Settings" />
      <AdminLayout>
        {hasFacilityId && <PageBody user={user} facilities={facilities} />}
      </AdminLayout>
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  user: select.adminSession.user(state),
  firstFacility: select.adminSession.firstFacility(state),
  facilities: select.adminSession.facilities(state),
});

export const PageAdminFacilitySettings = connect(mapStateToProps)(
  PageAdminFacilitySettingsPresenter,
);
